import { Component, OnDestroy, OnInit } from '@angular/core';
import { MICROSERVICES } from '../../constants/web-services';
import { APPLICATIONSERVICE } from '../../constants/application-service';
import { AppBaseService } from '../../services/http.service';
import { MatDialog } from '@angular/material/dialog';
import { Subject, takeUntil } from 'rxjs';
import { ReportService } from '../../services/report.service';
import { AuthService } from '../../services/auth.service';
import { printExport } from '../../enums/configuration-modules.enum';
import { MultiLanguageService } from '../multi-language/multi-language.service';
declare const PDFObject: any;

@Component({
  selector: 'app-pdf-viewer2',
  templateUrl: './pdf-viewer2.component.html',
  styleUrls: ['./pdf-viewer2.component.scss']
})
export class PdfViewer2Component implements OnInit, OnDestroy {
  protected _onDestroy = new Subject<void>();
  reportPayload: any;
  reportLabPayload: any;
  componentLoaded: boolean = false;
  userRightList: any= [];
  exportFlag: boolean= false;
  exportTypes = [
    { id: '1', active: true, code: 'xlsx', desc: 'Excel' },
    { id: '2', active: true, code: 'doc', desc: 'DOC' },
    { id: '3', active: true, code: 'csv', desc: 'CSV' }
  ];
  reportSecondPayload: any;
  languageList: any[]=[];
  selectedLanguageCode: string = 'en';
  selected: any;
  language: string="";
  reportThirdPayload: any;

  constructor(
    private httpService: AppBaseService,
    public dialog: MatDialog,
    private reportService: ReportService,
    public authService: AuthService,
    private langService: MultiLanguageService,
  ) {}

  ngOnInit(): void {
    // localStorage.setItem("lan", "en");
    this.language= localStorage.getItem("lan") || "en";
    this.componentLoaded = true;
    this.getUserInfo();
    this.reportPrint();
    this.getlanguagedata();
  }
  getlanguagedata() {
    this.langService.getLanguageListPromise().then((data: any[]) => {
      this.languageList = data;
  
      const defaultLanguage = this.languageList.find(lang => lang?.code.toLowerCase() === this.language.toLowerCase());
      this.selected = defaultLanguage ? defaultLanguage : this.languageList[0];
      this.selectedLanguageCode = this.mapLanguageToCode(this.selected.desc);
      localStorage.setItem("lan", this.selectedLanguageCode);

    });
  }
  
  changeLanguage(event: any) {
    this.selected = event.value;
    this.selectedLanguageCode = this.mapLanguageToCode(this.selected.desc);
    localStorage.setItem("lan", this.selectedLanguageCode);
  
    this.reportPrint();
  }
  
  mapLanguageToCode(language: string): string {
    switch (language) {
      case 'English': return 'en';
      case 'Malay': return 'my';
      case 'Thai': return 'th';
      default: return 'en';
    }
  }
  
  getUserInfo() {
    const reportPayload = localStorage.getItem("reportPayload");
    const isFromMis = reportPayload ? JSON.parse(reportPayload)?.isFromMis ?? false : false;
  
    if (isFromMis) {
      this.exportFlag = true;
      return;
    }
    this.authService.getUserInfo().then((value: any) => {
      this.userRightList = value.userSpecialRightList;
      if (this.userRightList && this.userRightList.length > 0) {
        this.userRightList.forEach((element) => {
          if (element.specialRightCode == printExport.printExport)
            this.exportFlag = true;
        });
      }
    });
}
  ngOnDestroy(): void {
    this._onDestroy.next();
    this._onDestroy.complete();
    localStorage.removeItem("patientLablePayload");
    localStorage.removeItem("billPayload");
    localStorage.removeItem("adtPayload");
  }

  reportPrint() {
    this.reportPayload = JSON.parse(localStorage.getItem("patientLablePayload"));
    this.reportLabPayload = JSON.parse(localStorage.getItem("reportNewPayload"));
    this.reportSecondPayload = JSON.parse(localStorage.getItem("billPayload"));
    const urlParams = new URLSearchParams(window.location.hash.split('?')[1]);
    const payloadKey = urlParams.get('payloadKey') || 'billPayload';
    this.reportSecondPayload = JSON.parse(localStorage.getItem(payloadKey));
    
    const Key = urlParams.get('Key') || 'adtPayload';
    this.reportThirdPayload = JSON.parse(localStorage.getItem(Key));
    const path = window.location.pathname.toLowerCase();
    if (!this.reportPayload && !this.reportSecondPayload && !this.reportThirdPayload && !this.reportLabPayload) {
      console.error("No report payload found in local storage.");
      return;
    }
    else if (path.includes("/billing/")) {
      if(this.reportSecondPayload && this.reportSecondPayload.isBilling) {
      if(this.reportSecondPayload) {
        this.multipleBillingReportsAPI(this.reportSecondPayload)
        // localStorage.removeItem("billPayload");
        // this.reportSecondPayload=null;
      } 
    }}
     else if (path.includes("/adt/")) {
      if(this.reportThirdPayload && this.reportThirdPayload.isAdt) {
      if(this.reportThirdPayload) {
        this.multipleAdtReportsAPI(this.reportThirdPayload)
        // localStorage.removeItem("adtPayload");
        // this.reportThirdPayload=null;
      } 
    }}
    else if (path.includes("/lab/")) {
      if(this.reportLabPayload && this.reportLabPayload.isLab) { 
      let serviceName = "";
      if(this.reportLabPayload.isBarcode) serviceName = APPLICATIONSERVICE.REPORT_GET_COMMON_REPORT;
      else serviceName = APPLICATIONSERVICE.REPORT_GENERATE_VIEW;

      this.reportPrintAPI(
        MICROSERVICES.LAB_SERVICE,
        serviceName,
        this.reportLabPayload
      );
    }
    }
    else{
      this.multipleReportsAPI(this.reportPayload);
    }
  }

  reportPrintAPI(resourceUrl: string, reportGeneratePath: string, reqPayload: any) {
    this.httpService.setResourceURL(resourceUrl);
    this.httpService
      .postResource(reportGeneratePath, reqPayload)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((result: any) => {
        // PDFObject.embed(result.payload, "#pdfContainer");
        if (result.payload) {
          console.log(result.payload);

          // Remove the prefix "data:application/pdf;base64,"
          const base64Data = result.payload.split(",")[1];

          // Convert base64 -> binary -> Blob
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const file = new Blob([byteArray], { type: "application/pdf" });

          // Create a temporary object URL
          const fileURL = URL.createObjectURL(file);
          PDFObject.embed(fileURL, "#pdfContainer");
        }
        if (!this.componentLoaded) {
          window.location.reload();
        }
      });
  }

  multipleReportsAPI(payLoad: any) {
    const reqPayload = this.formatGenericReportPayload(payLoad);
    this.reportPrintAPI(
      MICROSERVICES.OPD_SERVICE,
      APPLICATIONSERVICE.REPORT_GENERATE_VIEW,
      reqPayload
    );
  }

  formatGenericReportPayload(report: any): any {
    return {
      transactionId: report.transactionId,
      type: report.type,
      reportName: report.reportName
    };
  }

  multipleBillingReportsAPI = (payLoad: any) => {
    let payloadres="";
    let requestPayload;
    payloadres=payLoad;
    return new Promise<void>((resolve) => {
        requestPayload = this.formatBillingReportPayload(payloadres);

      this.reportPrintAPI(
        MICROSERVICES.BILLING_SERVICE,
        APPLICATIONSERVICE.REPORT_GET_COMMON_REPORT,
        requestPayload,
      );
      resolve();
    });
  };  

    multipleAdtReportsAPI = (payLoad: any) => {
    let payloadres="";
    let requestPayload;
    payloadres=payLoad;
    return new Promise<void>((resolve) => {
        requestPayload = this.formatAdtReportPayload(payloadres);

      this.reportPrintAPI(
      MICROSERVICES.OPD_SERVICE,
      APPLICATIONSERVICE.REPORT_GENERATE_VIEW,
      requestPayload
    );
      resolve();
    });
  }; 

  formatAdtReportPayload(reportPayload): any {
    const requestPayload = {
      type: reportPayload.type,
      reportName: reportPayload.reportName,
      transactionId: reportPayload.transactionId,
    }
    return requestPayload;
  }

   /**
   *
   *
   * @return {*}  {*}
   * @memberof PdfViewerComponent
   */
   formatBillingReportPayload(reportPayload): any {
    const requestPayload = {
      type: reportPayload.type,
      reportName: reportPayload.reportName.toUpperCase(),
      parameterList: [
        {
          parameter: "id",
          value: reportPayload.transactionId,
          dataType:"Long"
        },
        {
          parameter: "isReprint",
          value: reportPayload.reprint,
          dataType:"Boolean"
        }
      ]
    }

    if(reportPayload.params && reportPayload.params.length > 0) {
      reportPayload.params.forEach(param => {
        requestPayload.parameterList.push({
          parameter: param.name.toLowerCase(),
          value: param.value,
          dataType: param.dataType
        });
      });
    }

    return requestPayload;
  }
  exportfile(valuelist) {
    this.reportPayload = JSON.parse(localStorage.getItem("patientLablePayload"));
    if(this.reportPayload==null || this.reportPayload==undefined){
      this.reportPayload = JSON.parse(localStorage.getItem("reportNewPayload"));
    }
    if(this.reportPayload==null || this.reportPayload==undefined){
      const urlParams = new URLSearchParams(window.location.hash.split('?')[1]);
      const Key = urlParams.get('Key') || 'adtPayload';
      this.reportPayload = JSON.parse(localStorage.getItem(Key));
    }
    if(this.reportPayload==null || this.reportPayload==undefined){
    const urlParams = new URLSearchParams(window.location.hash.split('?')[1]);
    const payloadKey = urlParams.get('payloadKey') || 'billPayload';
    this.reportPayload = JSON.parse(localStorage.getItem(payloadKey));
    }

    const fileTypeMap = { 1: "xlsx",2: "docx",3: "csv"};  
    if (fileTypeMap[valuelist.id]) {
      this.exportfileType(fileTypeMap[valuelist.id]);
    } else {
      this.reportService.printReport(
        this.reportPayload.transactionId,
        this.reportPayload.type,
        this.reportPayload.reportName
      );
    }
  }
  
  /**
   * Exports the file based on the report type.
   *
   * @param {string} fileType
   */
  exportfileType(fileType: string) {
    if (!this.reportPayload) return;
      const {isReports,isBilling,isStock,
      isDietKitchen,isLab,isBarcode,transactionId,
      reportName,reprint,params,parameterList
    } = this.reportPayload;
  
    if (isReports) {
      this.reportPayload.type = fileType;
      this.reportService.printMISReport(this.reportPayload, fileType, reportName);
    } else if (isBilling) {
      this.reportService.printReportBillingExport(transactionId, fileType, reportName, reprint, params || []);
    } else if (isStock || isDietKitchen) {
      this.reportService.printReportStock(this.reportPayload, fileType, reportName, false);
    } else if (isLab) {
      if (isBarcode) {
        this.reportService.printReportLabBarcode(parameterList, fileType, reportName);
      } else {
        this.reportService.printReportStock(this.reportPayload, fileType, reportName, true);
      }
    } else {
      this.reportService.printReport(transactionId, fileType, reportName);
    }
  }
  
}
